import { MODAL_TYPE_POST_EDITOR, MODAL_TYPE_ADD_CATEGORIES } from '@wix/communities-blog-client-common';

export const MESSAGE_TYPES = {
  GO_BACK: 'goBack',
  NAV_BUTTON_PRESSED: 'navButtonPressed',
  ACTION_SHEET_ITEM_PRESSED: 'actionSheetItemPressed',
  DISMISS_MODAL: 'dismissModal',
  DIALOG_DISMISSED: 'dialogDismissed',
  MEDIA_MANAGER_IMAGES_SELECTED: 'mediaManagerImagesSelected',
};

export const DIALOG_BUTTON_VALUES = {
  CANCEL: 'cancel',
  DELETE_POST: 'deletePost',
  DISCARD_CHANGES: 'discardChanges',
};

export const NAV_BUTTON_VALUES = {
  POST_MENU: 'postMenu',
  POST_EDITOR_MENU: 'postEditorMenu',
  SAVE_CATEGORIES: 'saveCategories',
};

export const POST_ACTION_SHEET_VALUES = {
  FOLLOW: 'followPost',
  UNFOLLOW: 'unfollowPost',
  EDIT: 'editPost',
  SHARE: 'sharePost',
  PIN: 'pinPost',
  UNPIN: 'unpinPost',
  ENABLE_COMMENTING: 'enablePostCommenting',
  DISABLE_COMMENTING: 'disablePostCommenting',
  DELETE: 'deletePost',
};

export const POST_EDITOR_ACTION_SHEET_VALUES = {
  PUBLISH: 'publishPost',
  SAVE: 'savePost',
  ADD_CATEGORIES: 'addCategories',
  DISCARD_CHANGES: 'discardChanges',
};

export const CATEGORY_ACTION_SHEET_VALUE = 'categorySelect';

export const ONE_APP_MODALS = [MODAL_TYPE_POST_EDITOR, MODAL_TYPE_ADD_CATEGORIES];
